// NOTE: When defining or renaming routes, please make sure the backend configuration (backend/app/etc/config.php) is
// also updated. Failure to do so will cause a 404 Status Code on your new / renamed route.
export default {
    siteMap: '/sitemap',
}
